<template>
  <div>
    <b-container>
      <b-row class="justify-content-center mt-5">
        <b-col class="text-center" cols="10">
          <h2 class="text-muted d-inline">
            <font-awesome-icon icon="clipboard-list" class="mr-2" />
            Packages
            <a
              v-b-modal.modal-newPackage
              class="btn btn-sm btn-info ml-2 rounded rounded-pill"
            >
              <font-awesome-icon icon="plus-circle" class="mr-2" />
              Add new
            </a>
          </h2>

          <hr />
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col>
          <div v-if="packages">
            <b-table
              :items="packages"
              :fields="packageFields"
              striped
              borderless
              stacked="md"
            >
              <template v-slot:cell(title)="data">
                <b-link
                  :to="{
                    name: 'Package',
                    params: {
                      packageId: data.item.id,
                    },
                  }"
                  class="btn btn-sm btn-pill btn-primary"
                >
                  {{ data.item.title }}
                </b-link>
              </template>
              <template v-slot:cell(client)="data">
                <b-link
                  :to="{
                    name: 'Client',
                    params: { clientId: data.item.client_id },
                  }"
                  class="btn btn-sm btn-pill btn-primary"
                >
                  {{ data.item.client }}
                </b-link>
              </template>

              <template v-slot:cell(isActive)="data">
                <font-awesome-icon
                  :icon="data.item.isActive ? 'check-circle' : 'times-circle'"
                  :class="data.item.isActive ? 'text-success' : 'text-danger'"
                />
              </template>
              <template v-slot:cell(actions)="data">
                <b-link
                  class="btn btn-sm btn-danger mr-2"
                  @click="deletePackage(data.item.id)"
                  ><font-awesome-icon icon="edit" class="mr-2" />DELETE
                </b-link>
              </template>
            </b-table>
          </div>
          <div v-else>
            No packages.
          </div>
        </b-col>
      </b-row>
    </b-container>
    <NewPackage />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import NewPackage from "@/components/NewPackage.vue";

export default {
  components: { NewPackage },
  data() {
    return {
      loading: true,
      token: this.$store.state.login.token,
      apiUrl: this.$store.state.api.url,
      packageFields: [
        {
          key: "title",
          label: "Package title",
        },
        {
          key: "projects",
          label: "Projects",
        },
        {
          key: "actions",
          label: "",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      packages: "api/getPackages",
    }),
  },
  created() {
    this.$store.dispatch("api/fetchPackages");
  },
  methods: {
    deletePackage: function(packageId) {
      this.$confirm({
        message: `Si prepričan? `,
        button: {
          no: "Prekliči",
          yes: "DA",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store
              .dispatch("api/deletePackage", packageId)
              .then(() => {
                this.$router.go();
              })
              .catch((err) => console.log(err));
          }
        },
      });
    },
  },
};
</script>
